/** URL trang quản lý đơn theo chi nhánh (team.domain) của user. */
export function userManagementOrdersUrl(user) {
    if (!user)
        return "";
    const direct = user.management_orders_url;
    if (direct) {
        return String(direct).trim();
    }
    const domain = user.agency_domain;
    if (!domain)
        return "";
    const host = String(domain)
        .trim()
        .replace(/^https?:\/\//i, "")
        .replace(/\/+$/, "");
    if (!host)
        return "";
    const proto = typeof window !== "undefined" && window.location.protocol === "https:"
        ? "https:"
        : "http:";
    return `${proto}//${host}`;
}
